import React from 'react';
import styled from 'styled-components';
import ImageLazy from '../common/ImageLazy';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

import useTracking from '../Tracking/useTracking';
import { mergeDeep } from '../../lib/utils.js';

const PosterCarouselWrapper = styled.div `
    max-width: 1920px;
    margin: 0 auto;
    padding: ${p=>p.padding};
    text-align:left;

    *:focus{
        outline: 0;
    }

    @media (max-width: 995px){
        text-align: center;
        padding: ${p=>p.paddingMobile};
    }

    .slick-arrow {
        top: 50%;
        z-index: 9;
        width: 0px;
        height: 0px;
        position: absolute;
        border-style: solid;
        transform: translateY(-20px);
        cursor: pointer;
        outline: none;
        font-size: 0;
        line-height: 0;
        color: transparent;
        background: transparent;
    }


    .slick-prev {
        left: 0;
        border-width: 24px 24px 24px 0;
        border-color: ${p => `transparent ${p.arrowBgColor} transparent transparent` };
    }

    .slick-next {
        right: 0;
        border-width: 24px 0 24px 24px;
        border-color: ${p => `transparent transparent transparent ${p.arrowBgColor}` };
    }
`;

const Title = styled.h3 `
    color: ${p => p.titleColor};
    font-size: 40px;
    padding: 0 8px;
    margin: 0 0 12px;
    font-weight: 500;
    line-height: 1.25;
    text-transform: uppercase;

    @media (max-width: 700px){
        margin: 0 0 15px;
    }

    @media (max-width: 995px){
        font-size: 4.5vw;
        letter-spacing: 1px;
        padding: 0;
    }
`;

const Description = styled.p `
    color: ${p => p.descriptionColor};
    padding: 0 8px;
    margin-bottom: 20px;
    font-size: 24px;

    &:empty { display: none; }
    
    @media (max-width: 700px){
        font-size: 16px;
    }

    @media (max-width: 995px){
        padding: 0;
        margin-right: auto;
        filter: brightness(50%);
        max-width: none;
    }
`;


const SeriesLink = styled.a `
    display: block;
    padding: 8px;
    border: 0;
    cursor: pointer;
    
    @media (max-width: 995px){
        padding: 4px;
    }
`;

const SeriesImage = styled(ImageLazy)
`
    display: block;
    width: 100%;
    max-width:${p => p.maxWidth}px;
    outline: none;

`;


const PosterCarousel = ({
    title = '',
    titleColor = '#FFF',
    description = '',
    descriptionColor = '#FFF',
    numSlides = 4,
    settings,
    padding = '70px 89px 40px',
    paddingMobile = '60px 0 20px',
    posters = [],
    arrowBgColor = '#fff'
}) => {

    let defaultSettings = {
        slidesToShow: numSlides,
        slidesToScroll: numSlides,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        draggable: true,
        touchMove: false
    };

    let finalSettings = mergeDeep(defaultSettings || {}, settings || {});
    //Force  enforcing responsive properties if present
    if (settings && settings['responsive']) finalSettings['responsive'] = settings['responsive'];


    //We don't want more slides then we have items
    if (finalSettings.slidesToShow > posters.length) {
        finalSettings.slidesToShow = posters.length;
        finalSettings.slidesToScroll = posters.length;
    }

    let maxWidth = 1920 / numSlides;

    const { trackAndRedirect } = useTracking();

    const handleClick = (e, position, href = null, target = null) => {
        e.stopPropagation();
        e.preventDefault();
        let payload = { component: 'PosterCarousel', position, title: e.target.alt };
        trackAndRedirect(payload, href, target);
    };
    return (
        <PosterCarouselWrapper arrowBgColor={arrowBgColor}>
			<Title dangerouslySetInnerHTML={{ __html: title }} titleColor={titleColor} />
			{description && <Description dangerouslySetInnerHTML={{ __html: description }} descriptionColor={descriptionColor} />}
			<Slider {...finalSettings}>
				{ maxWidth && posters.map((img,position) => <SeriesLink href={img.href} onClick={(e) => {handleClick(e,position,img.href,img.target);}} key={position}>
				    <SeriesImage src={img.imageSrc} title={img.title} alt={img.title} maxWidth={maxWidth} />
			    </SeriesLink>)}
			</Slider>
		</PosterCarouselWrapper>
    );
};

export default PosterCarousel;
